module.exports = __webpack_public_path__ + "img/polygon.8ad3cf4c.png";